import type { CreateFundraisingRequest, FundraisingResponse } from '@shared/schemas';

import api from '@/shared/api/api-client';

import type { AddFundraisingGateway } from './add-fundraising.gateway';

/**
 * Real implementation over the shared api client. The single place that knows
 * the create endpoint. The draft → snake_case body mapping lives in the shared
 * domain (`toCreateRequest`), so the gateway just posts the request.
 */
export const httpAddFundraisingGateway: AddFundraisingGateway = {
  createFundraising: (request: CreateFundraisingRequest) =>
    api.post<FundraisingResponse>('/fundraisings', request),
};
